"use client";

import { getLink } from "@utils/linkUtils";
import classNames from "classnames";
import { useLocale } from "next-intl";
import Image from "next/image";
import React from "react";

import useBreakPoint from "@/hooks/useBreakpoint";
import useMediaQuery from "@/hooks/useMediaQuery";
import { EditorialModuleImage } from "@/types";

import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "../ui/Button/Button";
import { Editorial2Col_CorporateText } from "./types";

interface ColumnProp {
  entry: EditorialModuleImage | Editorial2Col_CorporateText;
}

export default function Column({ entry }: ColumnProp) {
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const locale = useLocale();

  if (entry.type === "editorialModuleImage") {
    let column = entry as EditorialModuleImage;
    return (
      <div className={classNames("md:w-5/12 w-full flex justify-center max-md:order-1")}>
        <Image
          src={isDesktop ? column.image.url : column.mobileImage?.url || column.image.url}
          alt={isDesktop ? column.image.title : column.mobileImage?.title || column.image.title}
          width={683}
          height={511}
          className="w-full rounded-2xl object-cover"
        />
      </div>
    );
  } else if (entry.type === "editorial2Col_CorporateText") {
    let column = entry as Editorial2Col_CorporateText;
    return (
      <div className={classNames("md:w-4/12 max-md:order-2 w-full")}>
        {column.title && <p className="font-primary uppercase text-l mb-l md:text-xl md:mb-xl text-wrap">{column.title}</p>}
        {column.body && <h3 className="font-secondary text-m font-secondary-light mb-l leading-[22.5px] whitespace-pre text-wrap">{column.body}</h3>}
        {column.quoteTitle && <p className="font-primary uppercase font-bold text-l mb-xl font-medium md:text-xl">&quot;{column.quoteTitle}&quot;</p>}
        {column.subtitle && <p className="font-secondary font-normal text-m">{column.subtitle}</p>}
        {entry.cta && (
          <div className="flex justify-center md:justify-normal md:mt-xl">
            <Button
              href={getLink(entry.cta, locale)}
              type="button"
              size={ButtonSize.MEDIUM}
              variant={ButtonVariant.PRIMARY}
              theme={ButtonTheme.BLACK}
            >
              {entry.cta.label}
            </Button>
          </div>
        )}
      </div>
    );
  }
}
